import { ThemeColor } from '@/enums'
import { Button } from '@surein/ui'
import { useTranslation } from 'react-i18next'
import { Typography } from '../../atoms'
import { ContactInfo } from '../../molecules'
import { Card, Column } from '../../styled'
import { ButtonContainer, Contact, Container, Emoji, PageInfo } from './styles'
import React from 'react'

export interface ErrorViewProps {
  onBack: () => void
}

const useMessages = () => {
  const { t } = useTranslation()
  return {
    title: t('error_view_title'),
    subtitle: t('error_view_subtitle'),
    buttonText: t('error_view_button_text'),
    contactTitle: t('error_view_contact_title'),
    contactSubtitle: t('error_view_contact_subtitle'),
  }
}

export const ErrorView: React.FC<ErrorViewProps> = ({ onBack }) => {
  const messages = useMessages()

  return (
    <Container>
      <PageInfo>
        <Emoji>⛈</Emoji>
        <Column alignItems="center" gap="8px">
          <Typography variant="h4">{messages.title}</Typography>
          <Typography color={ThemeColor.b50} variant="p1Body">
            {messages.subtitle}
          </Typography>
        </Column>
        <ButtonContainer>
          <Button onClick={onBack} shape="square">
            {messages.buttonText}
          </Button>
        </ButtonContainer>
      </PageInfo>
      <Contact>
        <Card responsive withoutBorder>
          <ContactInfo
            photo="chatblock"
            showAvailableBtn
            subtitle={messages.contactSubtitle}
            title={messages.contactTitle}
            withGap
          />
        </Card>
      </Contact>
    </Container>
  )
}
